(function ($) {

    $(document).ready(function () {
        // $('.news-grid .col-wrapper a').html("Read More");
        var btnWidth = $(".news-grid .intro .btn-wrapper").outerWidth() + "px";

        $(".news-grid .intro .text-wrap").css({width: "calc(100% - " + btnWidth + ")"});

        $(".news-grid .col-two .card .text-wrap h4").dotdotdot({
            height: 84,
            fallbackToLetter: true,
            watch: true,
        })

    });

})(jQuery);